<template>
  <svg-icon :icon="icon" :class="{'type-icon': true, 'cls': !!cls}"></svg-icon>
</template>

<script>
import SvgIcon from './SvgIcon'

const spaceIcon = {
  'own': 'type-folder',
  'collab': 'type-collab-folder',
  'enterprise': 'type-external-collab-folder',
  'external': 'type-external-collab-folder',
  'user': 'type-external-user',
  'trash': 'delete',
  'virus': 'virus',
  'department': 'type-department-folder',
  'recent': 'recent'
}

export default {
  name: 'SpaceIcon',
  components: {
    SvgIcon
  },
  props: {
    space: String,
    id: String,
    cls: String
  },
  computed: {
    icon () {
      return spaceIcon[this.space]
    }
  }
}
</script>
